import { Badge, Button, DatePicker, Dropdown, Form, Input, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Tuning2OutlineIcon } from '../../../../components/AppIcon'
import {
  DATE_FORMAT_DEFAULT,
  ISO_DATE_FORMAT,
  PROPOSAL_STATUS,
} from '../../../../constants'
import { checkValidFormFieldValue } from '../../../../utils/helper'
import { submissionMenu } from './ProposalPage'

const { Option, OptGroup } = Select

const ProposalPageAdvanceFilterV2 = props => {
  const { proposalTypeStore } = props || {}

  const [showFilter, setShowFilter] = useState(false)
  const [arrSubmissionMenu, setArrSubmissionMenu] = useState([])

  const history = useHistory()
  const location = useLocation()
  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  /** Hiển thị danh sách loại phiếu trình (Lọc theo loại phiếu trình) */
  const showSubmissionMenu = useMemo(() => {
    return arrSubmissionMenu?.length >= 3 ? (
      arrSubmissionMenu?.map((unit, index) => {
        return (
          <OptGroup
            label={
              <b
                style={{
                  fontSize: 15,
                  fontWeight: 500,
                  color: '#000',
                }}>
                {unit.name_group}
              </b>
            }
            key={unit.id_group}>
            {unit?.child
              ?.filter(
                item =>
                  item.id_child !== 'OVERTIME_DAYOFF' &&
                  item.id_child !== 'OVERTIME_HOLIDAY' &&
                  item.id_child !== 'LEAVE_NO_SALARY' &&
                  item.id_child !== 'LEAVE_ANNUAL'
              )
              .map(child => {
                return (
                  <Option value={child.id_child} key={child.id_child}>
                    {child.name_child}
                  </Option>
                )
              })}
          </OptGroup>
        )
      })
    ) : (
      <></>
    )
  }, [arrSubmissionMenu])

  useEffect(() => {
    ;(async () => {
      const response = await proposalTypeStore.getProposalTypes()

      const newProposalTypes = [
        {
          id_group: '3',
          name_group: 'Hành chính - Khác',
          child: response.data
            .filter(item => item.id.includes('OTHER_'))
            .map(item => ({
              id_child: item.id,
              name_child: item.name,
            })),
        },
      ]
      const updatedSubmissionMenu = submissionMenu.concat(newProposalTypes)
      setArrSubmissionMenu(updatedSubmissionMenu)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        type: queryStringParse?.type || undefined,
        proposal_status: queryStringParse?.proposal_status || undefined,
        create_user: queryStringParse?.create_user || undefined,
        created_at:
          queryStringParse?.created_at && queryStringParse?.created_at
            ? moment(queryStringParse.created_at)
            : undefined,
        date_range_query:
          queryStringParse?.from_date && queryStringParse?.to_date
            ? [
                moment(queryStringParse.from_date),
                moment(queryStringParse.to_date),
              ]
            : undefined,
      })
    }
  }, [queryStringParse, setFieldsValue, showFilter])

  const onFinish = values => {
    const params = {
      type: values?.type || null,
      proposal_status: values?.proposal_status || null,
      create_user: values?.create_user || null,
      created_at: values?.created_at
        ? moment(values?.created_at).format(ISO_DATE_FORMAT)
        : null,
      from_date: values?.date_range_query
        ? moment(values.date_range_query[0]).format(ISO_DATE_FORMAT)
        : null,
      to_date: values.date_range_query
        ? moment(values.date_range_query[1]).format(ISO_DATE_FORMAT)
        : null,
    }

    const queryStringStringify = queryString.stringify(
      {
        ...params,
        keyword: queryStringParse?.keyword || null,
        proposal_permission: queryStringParse?.proposal_permission || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )

    history.push(`/proposal?${queryStringStringify}`)
    onToggleFilter()
  }

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(queryStringParse?.type)) count++
    if (hasValue(queryStringParse?.proposal_status)) count++
    if (hasValue(queryStringParse?.create_user)) count++
    if (hasValue(queryStringParse?.created_at)) count++

    if (queryStringParse.from_date || queryStringParse.to_date) count++

    return count
  }, [queryStringParse])

  const handleClearFilter = () => {
    const queryStringStringify = queryString.stringify(
      {
        keyword: queryStringParse?.keyword || null,
        proposal_permission: queryStringParse?.proposal_permission || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )

    history.push(`/proposal?${queryStringStringify}`)
  }

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item label="Loại" name="type" style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  className="h-40"
                  placeholder={'Lọc theo loại'}
                  allowClear
                  showSearch
                  filterOption={(input, option) => {
                    const nameChild =
                      option?.children?.toString().toLowerCase() || ''
                    const idChild =
                      option?.value?.toString().toLowerCase() || ''
                    const searchText = input.toLowerCase()
                    return (
                      nameChild.includes(searchText) ||
                      idChild.includes(searchText)
                    )
                  }}>
                  {showSubmissionMenu}
                </Select>
              </Form.Item>
              <Form.Item
                label="Trạng thái"
                name="proposal_status"
                style={{ marginBottom: 16 }}>
                <Select
                  style={{ width: '100%' }}
                  className="h-40"
                  placeholder={'Lọc theo trạng thái'}
                  allowClear>
                  <Option value={PROPOSAL_STATUS.PENDING}>Chờ phê duyệt</Option>
                  <Option value={PROPOSAL_STATUS.APPROVAL}>Đã phê duyệt</Option>
                  <Option value={PROPOSAL_STATUS.REJECT}>Từ chối</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Người gửi"
                name="create_user"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder="Lọc theo người gửi"
                  allowClear
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Ngày tạo"
                name="created_at"
                style={{ marginBottom: 16 }}>
                <DatePicker
                  style={{ width: '100%' }}
                  allowClear
                  placeholder={'Ngày tạo '}
                  format={DATE_FORMAT_DEFAULT}
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Khoảng thời gian"
                name="date_range_query"
                style={{ marginBottom: 16 }}>
                <DatePicker.RangePicker
                  placeholder={['Từ ngày', 'Đến ngày']}
                  format={[DATE_FORMAT_DEFAULT, DATE_FORMAT_DEFAULT]}
                  style={{ width: '100%' }}
                  className="h-40"
                />
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()
                  handleClearFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default inject(
  'proposalStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'proposalTypeStore'
)(observer(ProposalPageAdvanceFilterV2))
